export const SYNC: unique symbol = Symbol('SYNC');
export const ASYNC: unique symbol = Symbol('ASYNC');
export const ALL_IN_ASYNC = 'ALL';
export const ASYNC_TYPES_DEFAULT_SUFFIX = ['PENDING', 'FULFILLED', 'REJECTED', '_'] as const;
